var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import * as preact from 'preact';
import dedent from 'ts-dedent';
var renderedStory;

function preactRender(story, domElement) {
  if (preact.Fragment) {
    // Preact 10 only:
    preact.render(story, domElement);
  } else {
    renderedStory = preact.render(story, domElement, renderedStory);
  }
}

var StoryHarness = function StoryHarness(_ref) {
  var showError = _ref.showError,
      name = _ref.name,
      title = _ref.title,
      storyFn = _ref.storyFn,
      domElement = _ref.domElement;
  var content = preact.h(storyFn, null);

  if (!content) {
    showError({
      title: "Expecting a Preact element from the story: \"".concat(name, "\" of \"").concat(title, "\"."),
      description: dedent(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        Did you forget to return the Preact element from the story?\n        Use \"() => (<MyComp/>)\" or \"() => { return <MyComp/>; }\" when defining the story.\n      "])))
    });
    return null;
  }

  return content;
};

export function renderToDOM(_ref2, domElement) {
  var storyFn = _ref2.storyFn,
      title = _ref2.title,
      name = _ref2.name,
      showMain = _ref2.showMain,
      showError = _ref2.showError,
      forceRemount = _ref2.forceRemount;

  if (forceRemount) {
    preactRender(null, domElement);
  }

  showMain();
  preactRender(preact.h(StoryHarness, {
    name: name,
    title: title,
    showError: showError,
    storyFn: storyFn,
    domElement: domElement
  }), domElement);
}